import {
	bitbucketOfferingSkusArray,
	bitbucketPlanLimitConfigs,
} from '../../../../uniform/components/pricing-calculator/src/configs/bitbucket.pricing-calculator-config.ts';
import {
	compassOfferingSkusArray,
	compassPlanLimitConfigs,
} from '../../../../uniform/components/pricing-calculator/src/configs/compass.pricing-calculator-config';
import {
	confluenceOfferingSkusArray,
	confluencePlanLimitConfigs,
} from '../../../../uniform/components/pricing-calculator/src/configs/confluence.pricing-calculator-config';
import {
	guardOfferingSkusArray,
	guardPlanLimitConfigs,
} from '../../../../uniform/components/pricing-calculator/src/configs/guard.pricing-calculator-config';
import {
	jiraOfferingSkusArray,
	jiraPlanLimitConfigs,
} from '../../../../uniform/components/pricing-calculator/src/configs/jira.pricing-calculator-config';
import {
	jpdOfferingSkusArray,
	jpdPlanLimitConfigs,
} from '../../../../uniform/components/pricing-calculator/src/configs/jpd.pricing-calculator-config';
import {
	jsmOfferingSkusArray,
	jsmPlanLimitConfigs,
} from '../../../../uniform/components/pricing-calculator/src/configs/jsm.pricing-calculator-config';
import {
	loomOfferingSkusArray,
	loomPlanLimitConfigs,
} from '../../../../uniform/components/pricing-calculator/src/configs/loom.pricing-calculator-config';
import {
	rovoDevOfferingSkusArray,
	rovoDevPlanLimitConfigs,
} from '../../../../uniform/components/pricing-calculator/src/configs/rovo-dev.pricing-calculator-config';
import {
	serviceCollectionOfferingSkusArray,
	serviceCollectionPlanLimitConfigs,
} from '../../../../uniform/components/pricing-calculator/src/configs/service-collection.pricing-calculator-config';
import {
	strategyCollectionOfferingSkusArray,
	strategyCollectionPlanLimitConfigs,
} from '../../../../uniform/components/pricing-calculator/src/configs/strategy-collection.pricing-calculator-config';
import {
	teamworkCollectionOfferingSkusArray,
	teamworkCollectionPlanLimitConfigs,
} from '../../../../uniform/components/pricing-calculator/src/configs/teamwork-collection.pricing-calculator-config';

import type { PlanLimitConfigs } from '../../../../uniform/components/pricing-calculator/src/types';

export const getOfferingSkusArrayByUrlSlug = (urlSlug: string): string[] | undefined => {
	const urlSlugToSkusArray: Record<string, readonly string[]> = {
		jira: jiraOfferingSkusArray,
		confluence: confluenceOfferingSkusArray,
		bitbucket: bitbucketOfferingSkusArray,
		loom: loomOfferingSkusArray,
		compass: compassOfferingSkusArray,
		guard: guardOfferingSkusArray,
		'rovo-dev': rovoDevOfferingSkusArray,
		'product-discovery': jpdOfferingSkusArray(),
		'service-management': jsmOfferingSkusArray,
		service: serviceCollectionOfferingSkusArray,
		strategy: strategyCollectionOfferingSkusArray,
		teamwork: teamworkCollectionOfferingSkusArray,
	};

	return urlSlugToSkusArray[urlSlug] as string[] | undefined;
};

export const getPlanLimitConfigsByUrlSlug = (urlSlug: string): PlanLimitConfigs[] | undefined => {
	const urlSlugToPlanLimitConfigs: Record<string, PlanLimitConfigs[]> = {
		jira: jiraPlanLimitConfigs,
		confluence: confluencePlanLimitConfigs,
		bitbucket: bitbucketPlanLimitConfigs,
		loom: loomPlanLimitConfigs,
		compass: compassPlanLimitConfigs,
		guard: guardPlanLimitConfigs,
		'rovo-dev': rovoDevPlanLimitConfigs,
		'product-discovery': jpdPlanLimitConfigs(),
		'service-management': jsmPlanLimitConfigs,
		service: serviceCollectionPlanLimitConfigs,
		strategy: strategyCollectionPlanLimitConfigs,
		teamwork: teamworkCollectionPlanLimitConfigs,
	};

	return urlSlugToPlanLimitConfigs[urlSlug];
};
